import { cloneDeep, get, head, isEmpty } from 'lodash';
import { Toast } from 'antd-mobile';
import { history } from 'umi';
import {
  qryPlayChancesDXP,
  toPlayDXP,
  qryLuckyDrawDetailWheelDXP,
  qryLuckyDrawDetailKOIDXP,
  qryLuckyDrawDetailReferralDXP,
  qryLuckyDrawDetailSignDXP,
  getAchieveRecordsDXP,
  batchCreateUtmLink,
  reducePointGetChancesDXP,
  getPromotionLuckyDrawRuleDXP,
  qryBalanceOfPointsDXP,
  qryAppCode,
  reducePointGetChancesRetryDXP,
  qryUserInfo,
  qryUserInfoDXP,
  qryNationalPrefix,
  getConfigParam,
  getConfigParamBatch,
  pointTransferDXP,
  pointTransferLimits,
  qryVoucherListDXP,
  qryThemesLatest,
  qryApiSgAuthToken,
  getUtmLink,
  getGAReportConfig,
  qryEshopUser,
  qryConfigItemParamValueByCode,
  getLocalI18n,
  getGameI18n,
  qryDefaultConfig,
} from '@/services';

export default {
  namespace: 'index',
  state: {
    gameCode: '',
    isDXP: true,
    dxpToken: {},
    activityList: [],
    defaultPlayChances: 0,
    winningUserList: [], // 中奖用户
    rewardsList: [],
    activityDetail: {},
    winningReward: {},
    exchangeChanceFlag: '', // 积分兑换抽奖标识
    Luckycode: '2',
    shortLink: '', // 生成的分享短链
    luckyDrawState: '',
    playChances: '',
    isPto: false, // 调用配置项查看是否是PTO dito项目，
    product: null,
    userDimension: null,
    fromGetMore: false,
    projectName: '',
    withoutAuthentification: 'false', // 是否关闭鉴权，false为需要鉴权，true为关闭了鉴权
    isUCAuthentication: false, // 是否走uc鉴权
    pointType: '', // 积分兑换抽奖机会的积分类型
    pageRenderDetail: {},
    referralServerUrl: '',
    isMulPoints: false,
    isWeb: false,
  },
  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *qryLuckyDrawDetailDXP({ payload }, { put, call, select }) {
      const initAppStr = window.localStorage.getItem('initApp');
      const initApp = JSON.parse(initAppStr) || {};
      const { product, userDimension } = history.location.query;
      // uc鉴权不需要phone
      const isUCAuthentication = yield select(({ index }) => index.isUCAuthentication);
      if (
        isEmpty(initApp.phone) &&
        product !== 'ESHOP' &&
        !isUCAuthentication &&
        userDimension === 'SUBS_MSISDN'
      ) {
        yield put({
          type: 'save',
          payload: {
            Luckycode: '3',
          },
        });
        return null;
      }
      let drawResp = {};
      if (payload.luckyDrawType === 'K') {
        // 锦鲤夺宝
        drawResp = yield call(qryLuckyDrawDetailKOIDXP, payload.gameCode) || {};
      } else if (payload.luckyDrawType === 'S') {
        // 签到
        drawResp = yield call(qryLuckyDrawDetailSignDXP, payload.gameCode) || {};
      } else if (payload.luckyDrawType === 'C' || payload.luckyDrawType === 'J') {
        // 分享
        drawResp = yield call(qryLuckyDrawDetailReferralDXP, payload.gameCode) || {};
      } else {
        // 大转盘九宫格
        drawResp = yield call(qryLuckyDrawDetailWheelDXP, payload.gameCode) || {};
      }

      try {
        const detailTemp = get(drawResp, 'data') || {};
        drawResp = {
          ...drawResp,
          retCode: drawResp.resultCode,
          retDesc: drawResp.resultMsg,
          data: {
            ...detailTemp,
            promotionName: detailTemp.gameName,
            promotionId: detailTemp.gameCode,
            drawMoreOneTime: detailTemp.allowMultiBet ? 'Y' : 'N',
            promotionCode: detailTemp.gameCode,
            luckyDrawType: detailTemp.gameType || payload.luckyDrawType,
            lotteryStatus: detailTemp.gameState,
            state: detailTemp.gameState,
            playChances: detailTemp.playChancesNum,
            numberOfParticipants: detailTemp.gameParticipantsNum,
            numberOfUserParticipants: detailTemp.userParticipantsNum,
            pointExchangeChanceFlag: detailTemp.canPointsToRedeemChance ? 'Y' : 'N',
            taskCenterPromoId: detailTemp.challengeId,
            reducePointNum: detailTemp.pointNumForExchangeChance,
            exchangeMethod: detailTemp.pointsExchangeChanceMethod,
            exceedLimitTimes: detailTemp.isExceedLimitTimes,
            participentShowFlag: detailTemp.canShowParticipentTimes,
            shortLink: detailTemp.c2cShortLink,
            subNumType: detailTemp.subscriberScopeForRewardClaim,
            chooseSubNumMethod: detailTemp.chooseSubscriberMethod,
            promotionPointExchangeRuleDto: detailTemp.pointsExchangeChanceRule,
            enabled: detailTemp.isRequireAudit ? 'Y' : 'N',
            switchSetting: detailTemp.isDefaultOpen,
            promotionMediaItemDtoList: detailTemp.mediaItemList,
            promotionRewardMemDtoList: detailTemp.rewardList?.map(rewardItem => ({
              ...(rewardItem || {}),
              numberOfPrizes: rewardItem.rewardNum,
            })),
            promotionAttrList: detailTemp.attrList,
            promotionDailyCheckInDto: {
              ...(detailTemp.dailyCheckInRule || {}),
              patchSwitch: detailTemp?.dailyCheckInRule?.canPatch,
            },
            promotionEventLinkList: detailTemp.eventUrlList?.map((item, index) => ({
              ...item,
              eventLinkId: index + 1,
            })),
            column1: detailTemp.nextGameStartDate,
            column2: detailTemp.nextGameDrawDate,
            patchMaximumTime: detailTemp.patchMaximumTimes,
            patchConsumeType: detailTemp.patchPointType,
            patchConsumeNum: detailTemp.patchPointAmount,
            linkContentType: detailTemp.linkTypeOfTC,
            effDate: detailTemp.startDate,
            expDate: payload.luckyDrawType === 'K' ? detailTemp.drawingDate : detailTemp.endDate,
          },
        };
        const detailData = get(drawResp, 'data');
        const detailCode = get(drawResp, 'retCode');
        const drawType = get(detailData, 'luckyDrawType');
        const drawRewardsList = get(detailData, 'promotionRewardMemDtoList') || [];
        yield put({
          type: 'save',
          payload: {
            Luckycode: detailCode,
          },
        });
        // 0表示成功
        if (detailCode === '0') {
          const renderDetailObj =
            drawType === 'J'
              ? JSON.parse(
                detailData?.promotionMediaItemDtoList?.find(
                  item => item.itemPartType === 'D' && item?.mediaType === 'J',
                )?.extData || '{}',
              )
              : {};
          const drawColumnObj = drawType === 'J' ? JSON.parse(detailData?.column1) : {};
          yield put({
            type: 'save',
            payload: {
              activityDetail: detailData || {},
              Luckycode: detailCode,
              luckyDrawType: drawType,
              luckyDrawState: get(detailData, 'state'),
              exchangeChanceFlag: get(detailData, 'pointExchangeChanceFlag'),
              product: get(detailData, 'product'),
              userDimension: get(detailData, 'userDimension'),
              isManual: get(drawColumnObj, 'isManual'),
              applyTo: get(drawColumnObj, 'applyTo'),
              pageRenderDetail: renderDetailObj,
              referralServerUrl: detailData?.promotionMediaItemDtoList?.find(
                item => item.itemPartType === 'D' && item?.mediaType === 'J',
              )?.serverUrl,
              rewardsList: drawRewardsList,
            },
          });
        }
      } catch (detailErr) {
        Toast.show({ icon: 'fail', content: detailErr.Error });
      }
      return drawResp;
    },
    *getLuckyDrawRuleDXP({ payload }, { call }) {
      const { data } = yield call(getPromotionLuckyDrawRuleDXP, payload) || {};
      return data?.rulesDetail || '';
    },
    *getAchieveRecordsDXP({ payload }, { put, call }) {
      try {
        const recordResp = yield call(getAchieveRecordsDXP, payload);
        let recordList = cloneDeep(get(recordResp, 'data') || []);
        const recordCode = get(recordResp, 'resultCode');
        const recordDesc = get(recordResp, 'resultMsg');
        recordList = recordList.map(item => ({
          ...item,
          msisdn: item.userName,
        }));
        // 0表示成功
        if (recordCode === '0') {
          yield put({
            type: 'save',
            payload: {
              winningUserList: recordList || {},
            },
          });
        } else {
          Toast.show({ icon: 'fail', content: recordDesc });
        }
      } catch (recordErr) {
        Toast.show({ icon: 'fail', content: recordErr.Error });
      }
    },
    // 查询配置项信息
    *getConfigParamDXP({ payload }, { call }) {
      const paramBatchResp = yield call(getConfigParamBatch, payload);
      const paramData = get(paramBatchResp, 'data') || {};
      const paramCode = get(paramBatchResp, 'resultCode');
      const paramDesc = get(paramBatchResp, 'resultMsg');
      try {
        if (paramCode === '0') {
          return paramData?.[0] || {};
        }
        Toast.show({ icon: 'fail', content: paramDesc });
        return null;
      } catch (paramErr) {
        Toast.show({ icon: 'fail', content: paramErr.Error });
      }
      return null;
    },
    // 是否uc鉴权
    *isUCAuthentication({ payload }, { put, call }) {
      const ucResp = yield call(getConfigParam, payload);
      const ucData = get(ucResp, 'data') || {};
      const ucCode = get(ucResp, 'retCode');
      const ucDesc = get(ucResp, 'retDesc');
      try {
        if (ucCode === '0') {
          yield put({
            type: 'save',
            payload: {
              isUCAuthentication: ucData.paramValue === 'Y',
            },
          });
          return ucData;
        }
        Toast.show({ icon: 'fail', content: ucDesc });
        return null;
      } catch (ucErr) {
        Toast.show({ icon: 'fail', content: ucErr.Error });
      }
      return null;
    },
    // 查询是否需要鉴权
    *qryWithoutAuthentification({ payload }, { call, put }) {
      const authResp = yield call(getConfigParam, payload);
      const authData = get(authResp, 'data') || {};
      const authCode = get(authResp, 'retCode');
      const authDesc = get(authResp, 'retDesc');
      try {
        if (authCode === '0') {
          yield put({
            type: 'save',
            payload: {
              withoutAuthentification: authData?.paramValue,
            },
          });
          return authData.paramValue;
        }
        Toast.show({ icon: 'fail', content: authDesc });
        return null;
      } catch (authErr) {
        Toast.show({ icon: 'fail', content: authErr.Error });
      }
      return null;
    },
    *qryPlayChancesDXP({ payload }, { put, call }) {
      try {
        const chancesResp = yield call(qryPlayChancesDXP, payload);
        const chancesData = get(chancesResp, 'data');
        const chancesCode = get(chancesResp, 'resultCode');
        const chancesDesc = get(chancesResp, 'resultMsg');
        // 0表示成功
        if (chancesCode === '0') {
          yield put({
            type: 'save',
            payload: {
              defaultPlayChances: chancesData?.playChancesNum || 0,
            },
          });
        } else {
          Toast.show({ icon: 'fail', content: chancesDesc });
        }
      } catch (chancesErr) {
        Toast.show({ icon: 'fail', content: chancesErr.Error });
      }
    },
    *toPlayDXP({ payload }, { put, call }) {
      let playResp = yield call(toPlayDXP, payload);
      playResp = cloneDeep(playResp);
      playResp = {
        ...playResp,
        retCode: playResp.resultCode,
        retDesc: playResp.resultDesc,
        data: {
          ...(playResp?.data || {}),
          playChances: playResp?.data?.remainingPlayChances,
          promotionRewardMemDto: playResp?.data?.reward,
          exceedLimitTimes: playResp?.data?.isExceedLimitTimes,
        },
      };
      const playData = get(playResp, 'data') || {};
      const playCode = get(playResp, 'resultCode');
      const playDesc = get(playResp, 'resultDesc');
      // 0表示成功
      if (playCode === '0') {
        yield put({
          type: 'save',
          payload: {
            winningReward: playData,
          },
        });
        return playResp;
      }
      if (playCode === '-7') {
        return playResp;
      }
      Toast.show({ icon: 'fail', content: playDesc });
      return playResp;
    },
    // 生成短链接口
    *batchCreateUtmLink({ payload }, { put, call }) {
      try {
        const utmResp = yield call(batchCreateUtmLink, payload);
        const linkList = get(utmResp, 'data.linkList');
        const utmCode = get(utmResp, 'retCode');
        const utmDesc = get(utmResp, 'retDesc');
        // 0表示成功
        if (utmCode === '0') {
          yield put({
            type: 'save',
            payload: {
              shortLink: get(head(linkList), 'shortLink'),
            },
          });
          return utmResp;
        }
        Toast.show({ icon: 'fail', content: utmDesc });
        return null;
      } catch (utmErr) {
        Toast.show({ icon: 'fail', content: utmErr.Error });
        return null;
      }
    },
    // 积分兑换抽奖次数DXP
    *reducePointGetChancesDXP({ payload }, { put, call }) {
      try {
        let exchangeResp = yield call(reducePointGetChancesDXP, payload);
        exchangeResp = {
          ...exchangeResp,
          retCode: exchangeResp.resultCode,
          retDesc: exchangeResp.resultMsg,
          data: {
            playChances: exchangeResp?.data?.exchangedChanceNum,
            changeChances: exchangeResp?.data?.remainingChanceNum,
            retCode: exchangeResp.resultCode,
            retDesc: exchangeResp.resultMsg,
          },
        };
        const exchangeData = get(exchangeResp, 'data');
        const exchangeCode = get(exchangeResp, 'retCode');
        // 0表示成功
        if (exchangeCode === '0') {
          yield put({
            type: 'save',
            payload: {
              defaultPlayChances: exchangeData.playChances,
            },
          });
          return exchangeResp;
        }
        if (exchangeCode === '-2') {
          return exchangeResp;
        }
        Toast.show({
          content: get(exchangeResp, 'retDesc') || 'Point conversion failed. Please try again.',
        });
        return null;
      } catch (exchangeErr) {
        Toast.show({ icon: 'fail', content: exchangeErr.Error });
        return null;
      }
    },
    // 积分兑换抽奖次数重试DXP
    *reducePointGetChancesRetryDXP({ payload }, { put, call }) {
      try {
        let retryResp = yield call(reducePointGetChancesRetryDXP, payload);
        retryResp = {
          ...retryResp,
          retCode: retryResp.resultCode,
          retDesc: retryResp.resultMsg,
          data: {
            playChances: retryResp?.data?.exchangedChanceNum,
            changeChances: retryResp?.data?.remainingChanceNum,
            retCode: retryResp.resultCode,
            retDesc: retryResp.resultMsg,
          },
        };
        const retryData = get(retryResp, 'data');
        const retryCode = get(retryResp, 'retCode');
        // 0表示成功
        if (retryCode === '0') {
          yield put({
            type: 'save',
            payload: {
              defaultPlayChances: retryData.playChances,
            },
          });
          return retryResp;
        }
        if (retryCode === '-2') {
          return retryResp;
        }
        Toast.show({
          content: get(retryResp, 'retDesc') || 'Point conversion failed. Please try again.',
        });
        return null;
      } catch (retryErr) {
        Toast.show({ icon: 'fail', content: retryErr.Error });
        return null;
      }
    },
    // 批量查询配置项
    *getConfigParamBatch({ payload }, { call, put }) {
      const batchResp = yield call(getConfigParamBatch, payload);
      const configList = get(batchResp, 'data') || [];
      const projectObj =
        configList.find(item => item.paramCode === 'PROMOTION_PROGECT_IDENTIFICATION') || {};
      const timeFormateObj =
        configList.find(item => item.paramCode === 'TIME_DISPLAY_FORMAT') || {};
      const sensorsInitObj =
        configList.find(item => item.paramCode === 'EVENT_REPORT_SERVER_URL') || {};
      const gaResult = configList.find(item => item.paramCode === 'GA_REPORT_SERVER_CONFIG') || {};
      const withoutAuthentificationObj =
        configList.find(item => item.paramCode === 'webs.ecare.signcode.develop.model') || {};
      const isUCAuthenticationObj =
        configList.find(item => item.paramCode === 'use.UC.authentication.switch') || {};
      const isMulPointsObj =
        configList.find(item => item.paramCode === 'DC_LOYALTY_POINT-MULTIPLE-ACCOUNT') || {};

      const batchCode = get(batchResp, 'resultCode');
      const batchDesc = get(batchResp, 'resultMsg');

      try {
        if (batchCode === '0') {
          const timeFormate = get(timeFormateObj, 'paramValue') || 'YYYY-MM-DD HH:mm:ss';
          localStorage.setItem('timeFormate', timeFormate);
          yield put({
            type: 'save',
            payload: {
              isPto: projectObj.paramValue === 'PTO',
              projectName: projectObj.paramValue,
              projectNamedd: projectObj.paramValue,
              isUCAuthentication: isUCAuthenticationObj.paramValue === 'Y',
              withoutAuthentification: withoutAuthentificationObj.paramValue,
              sensorsUrl: sensorsInitObj.paramValue,
              gaResult: gaResult.paramValue,
              isMulPoints: isMulPointsObj.paramValue === '1',
            },
          });
          return configList;
        }
        Toast.show({ icon: 'fail', content: batchDesc });
        return [];
      } catch (batchErr) {
        Toast.show({ icon: 'fail', content: batchErr.Error });
      }
      return [];
    },
    // 获取谷歌埋点上报配置
    *getGAReportConfig(_, { call }) {
      try {
        const gaResp = yield call(getGAReportConfig);
        const gaCode = get(gaResp, 'resultCode');
        if (gaCode === '0') {
          return get(gaResp, 'data.configValue');
        }
      } catch {
        // ignore
      }
      return null;
    },
    // 查询是否是PTO项目，产品做项目的定制化
    // *qryProject({ payload }, { call, put }) {
    //   const resp = yield call(qryConfigItemParamValueByCode, { paramCode: payload });
    //   const paramValue = get(resp, 'data.paramValue');
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       isPto: paramValue === 'PTO',
    //       projectName: paramValue,
    //     },
    //   });
    //   return paramValue;
    // },

    // 查询用户信息
    *qryUserInfo({ payload }, { call }) {
      try {
        const userResp = yield call(qryUserInfo, payload);
        const userData = get(userResp, 'data');
        const userCode = get(userResp, 'retCode');
        const userDesc = get(userResp, 'retDesc');
        // 0表示成功
        if (userCode === '0') {
          return userData;
        }
        Toast.show({ icon: 'fail', content: userDesc });
        return {};
      } catch (userErr) {
        Toast.show({ icon: 'fail', content: userErr.Error });
        return {};
      }
    },
    // 查询用户信息
    *qryUserInfoDXP({ payload }, { call }) {
      try {
        const infoResp = yield call(qryUserInfoDXP, payload);
        const infoData = get(infoResp, 'data');
        const infoCode = get(infoResp, 'resultCode');
        const infoDesc = get(infoResp, 'resultMsg');
        // 0表示成功
        if (infoCode === '0') {
          return infoData;
        }
        Toast.show({ icon: 'fail', content: infoDesc });
        return {};
      } catch (infoErr) {
        Toast.show({ icon: 'fail', content: infoErr.Error });
        return {};
      }
    },
    // eshop通过token获取用户信息
    *qryEshopUser({ payload }, { call }) {
      try {
        const eshopResp = yield call(qryEshopUser, payload);
        const eshopData = get(eshopResp, 'data');
        const eshopCode = get(eshopResp, 'retCode');
        const eshopDesc = get(eshopResp, 'retDesc');
        // 0表示成功
        if (eshopCode === '0') {
          return eshopData;
        }
        Toast.show({ icon: 'fail', content: eshopDesc });
        return null;
      } catch (eshopErr) {
        Toast.show({ icon: 'fail', content: eshopErr.Error });
        return null;
      }
    },
    // 获取国内长途前缀接口
    *qryNationalPrefix({ payload }, { call }) {
      try {
        const prefixResp = yield call(qryNationalPrefix, payload);
        const prefixData = get(prefixResp, 'data');
        const prefixCode = get(prefixResp, 'resultCode');
        const prefixDesc = get(prefixResp, 'resultMsg');
        // 0表示成功
        if (prefixCode === '0') {
          return prefixData;
        }
        Toast.show({ icon: 'fail', content: prefixDesc });
        return {};
      } catch (prefixErr) {
        Toast.show({ icon: 'fail', content: prefixErr.Error });
        return {};
      }
    },
    *qryBalanceOfPointsDXP({ payload }, { call }) {
      try {
        const balanceResp = yield call(qryBalanceOfPointsDXP, payload);
        let balanceData = get(balanceResp, 'data');
        balanceData = {
          ...balanceData,
          points: balanceData.availablePoint,
          pointsInt: balanceData.availablePointInt,
          status: balanceData.state,
        };
        const balanceCode = get(balanceResp, 'resultCode');
        const balanceDesc = get(balanceResp, 'resultDesc');
        // 0表示成功
        if (balanceCode === '0') {
          return balanceData;
        }
        Toast.show({ icon: 'fail', content: balanceDesc });
        return {};
      } catch (balanceErr) {
        Toast.show({ icon: 'fail', content: balanceErr.Error });
        return {};
      }
    },
    *qryAppCode(_, { call }) {
      const appCodeResp = yield call(qryAppCode);
      return appCodeResp.data;
    },
    // 积分转账
    *pointTransferDXP({ payload }, { call }) {
      try {
        const transferResp = yield call(pointTransferDXP, payload);
        const transferData = get(transferResp, 'data') || {};
        const transferCode = get(transferResp, 'resultCode');
        // 0表示成功
        if (transferCode === '0') {
          return transferData;
        }
        return {};
      } catch (transferErr) {
        Toast.show({ icon: 'fail', content: transferErr.Error });
        return {};
      }
    },
    // 积分转账单笔最大限制
    *pointTransferLimits({ payload }, { call }) {
      try {
        const limitResp = yield call(pointTransferLimits, payload);
        const limitData = get(limitResp, 'data') || {};
        const limitCode = get(limitResp, 'resultCode');
        // 0表示成功
        if (limitCode === '0') {
          return limitData;
        }
        return [];
      } catch (limitErr) {
        Toast.show({ icon: 'fail', content: limitErr.Error });
        return [];
      }
    },
    // 查询用户劵实例
    *qryVoucherListDXP({ payload }, { call }) {
      try {
        const voucherResp = yield call(qryVoucherListDXP, payload);
        const voucherData = get(voucherResp, 'data');
        const voucherCode = get(voucherResp, 'resultCode');
        const voucherDesc = get(voucherResp, 'retDesc');
        // 0表示成功
        if (voucherCode === '0') {
          return voucherData || [];
        }
        Toast.show({ icon: 'fail', content: voucherDesc });
        return [];
      } catch (voucherErr) {
        Toast.show({ icon: 'fail', content: voucherErr.Error });
        return [];
      }
    },
    // 查询用户劵实例
    *qryThemesLatest({ payload }, { call }) {
      try {
        const themeResp = yield call(qryThemesLatest, payload);
        const themeData = get(themeResp, 'data');
        const themeCode = get(themeResp, 'resultCode');
        const themeDesc = get(themeResp, 'retDesc');
        // 0表示成功
        if (themeCode === '0') {
          return themeData || {};
        }
        Toast.show({ icon: 'fail', content: themeDesc });
        return {};
      } catch (themeErr) {
        Toast.show({ icon: 'fail', content: themeErr.Error });
        return {};
      }
    },
    *qryApiSgAuthToken({ payload }, { call }) {
      const result = yield call(qryApiSgAuthToken, payload);
      return result;
    },
    *getUtmLink({ payload }, { call }) {
      const result = yield call(getUtmLink, payload?.id);
      return result;
    },
    // 查询Eshop登录页面Url
    *qryEshopLoginUrl({ payload }, { call }) {
      const loginUrlResp = yield call(qryConfigItemParamValueByCode, { paramCode: payload });
      const loginUrl = get(loginUrlResp, 'data.paramValue');
      return loginUrl;
    },
    *getLocalI18n({ payload }, { call }) {
      try {
        const { appCode } = payload;
        const localI18nResp = yield call(getLocalI18n, appCode) || {};
        return localI18nResp || {};
      } catch (localI18nErr) {
        return {};
      }
    },
    *getGameI18n({ payload }, { call }) {
      const { promotionId } = payload;
      try {
        const gameI18nResp = yield call(getGameI18n, promotionId) || {};
        return gameI18nResp || {};
      } catch (gameI18nErr) {
        return {};
      }
    },
    *qryDefaultConfig(_, { call }) {
      const result = yield call(qryDefaultConfig);
      if (result && typeof result === 'object') {
        if (!isEmpty(result)) {
          window.sessionStorage.setItem('x-default-config', JSON.stringify(result));
        }
      }
    },
  },
};
